export enum BranchEnum {
    DE = 1,
    PL = 2,
    TR = 4,
}
